// Source: app/scripts/controllers/register-trader.js
/**
 * Created by ristes on 20.4.15.
 */




Auction.controller('RegisterTraderController', [
  '$scope',
  '$modal',
  '$filter',
  '$location',
  'toaster',
  'crudService',
  'Messages',
  function ($scope, $modal, $filter, $location, toaster, crudService, Messages) {
    $scope.entity = {};
    $scope.entity.lang = 'sq';
    $scope.allowCreate = false;


    var service = crudService('registered_users', {
      register: {
        method: 'POST',
        url: '/data/rest/registered_users/register_company'
      },
      checkFiscalNumber: {
        method: 'GET',
        isArray: false,
        url: '/data/rest/registered_users/check_company_unique_number'
      }
    });

    $scope.response = null;
    $scope.widgetId = null;

    $scope.showCaptcha = true;

    $scope.model = {
//      key: '6LdgoQITAAAAALJEkb87z5eLvsG1NlTZRwDLEznF'
      key: '6LcBx18tAAAAAIRbvC-leQ5rRLDIIuBBUDjVosAx'
    };

    $scope.setResponse = function (response) {
      $scope.response = response;
    };

    $scope.setWidgetId = function (widgetId) {
      $scope.widgetId = widgetId;
    };

    $scope.register = function () {
      var error = false;
      if ($scope.registerTrader.$invalid) {
        toaster.pop('error', $filter('translate')('error'), $filter(
          'translate')('eauction.fill_in_required_fields'));
        error = true;
      }






      if ($scope.entity.email !== $scope.entity.confirmEmail) {
        toaster.pop('error', $filter('translate')('error'), $filter(
          'translate')('eauction.confirm_email_missmatch'));
        error = true;
      }



      if (!$scope.pwStrength || $scope.pwStrength < 20) {
        // console.log('pwStrength');
        // console.log($scope.pwStrength);
        // toaster.pop('error', $filter('translate')('error'), $filter(
        //   'translate')('eauction.weak_password'));
        // error = true;
      }
      if ($scope.entity.password !== $scope.entity.confirmPassword) {
        toaster.pop('error', $filter('translate')('error'), $filter(
          'translate')('eauction.confirm_password_missmatch'));
        error = true;
      }

      if (!error) {
        var entity = {
          username : $scope.entity.username,
          password : $scope.entity.password,
          confirmPassword : $scope.entity.confirmPassword,
          email : $scope.entity.email,
          lang : $scope.entity.lang,
          language : $scope.entity.language,
          disabledTo : $scope.entity.disabledTo,
          phone : $scope.entity.phone,
          fiscalNumber : $scope.entity.fiscalNumber,
          companyName : $scope.entity.companyName,
          companyPhone : $scope.entity.companyPhone,
          address : $scope.entity.address,
          constitutionDate : $scope.entity.constitutionDate,
          placeName : $scope.entity.placeName,
          registerNumber : $scope.entity.registerNumber,
          isIntermediary : $scope.entity.isIntermediary,
          companyUniqueNumber: $scope.entity.companyUniqueNumber

        };
        service.register(
          entity
        , function () {
          $location.path("/login").search({
            info: 'eauction.trader_registered'
          })
        });
      }
    };

    $scope.checkFiscalNumber = function (companyUniqueNumber) {
      service.checkFiscalNumber({companyUniqueNumber: companyUniqueNumber}, function (data) {
        $scope.allowCreate = data.allowCreate;
        if(data.company){
          if(data.allowCreate){
            $scope.entity = data.company;
            $scope.entity.companyUniqueNumber = companyUniqueNumber;
          }

        }

        if(!data.allowCreate){
          Messages.error('Company already exists');
        }


        // console.log(data);
        // if(!data.id){
        //
        //   $scope.allowCreate = true;
        //   console.log('in checkFiskalNumber if ' + $scope.allowCreate)
        // }else{
        //   $scope.allowCreate = false;
        //   Messages.error('Company already exists');
        //   console.log('in checkcheckFiskalNumber else ' + $scope.allowCreate)
        // }
      })
    }





  }
]);
